import PropTypes from 'prop-types';
import 'react';
import warning from 'tiny-warning';
import { DEPRECATED_PROP_MESSAGES } from '../../constants/messages.js';
import { usePaginationContext } from './pagination.context.js';
import { TextInput } from '../text-input/text-input.component.js';
import { deprecatedProp } from '../core/deprecated-prop.js';
import { createComponent } from '../core/create-component.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const propTypes = {
    /**
   * @deprecated use `accessibleText` prop instead
   * Provide the text that should be used for screen readers.
   */ visuallyHiddenText: deprecatedProp(PropTypes.string, DEPRECATED_PROP_MESSAGES.accessibleText),
    /**
   * Provide the text that should be used for screen readers.
   */ accessibleText: PropTypes.string
};
/**
 * @subcomponent Pagination
 */ const PaginationInput = createComponent({
    displayName: 'PaginationInput',
    root: TextInput,
    propTypes,
    propConfig: {
        derivedProps () {
            const { labelId } = usePaginationContext();
            return {
                labelId
            };
        },
        processProps (_param, _param1) {
            var { accessibleText, visuallyHiddenText } = _param, props = _object_without_properties(_param, [
                "accessibleText",
                "visuallyHiddenText"
            ]), { labelId } = _param1;
            warning(props.as === undefined && props.component === undefined, 'props `as` and `component` are not supported for PaginationInput');
            const accessibleNode = accessibleText !== null && accessibleText !== undefined ? accessibleText : visuallyHiddenText;
            return _object_spread_props(_object_spread({
                'aria-label': accessibleNode !== null && accessibleNode !== void 0 ? accessibleNode : undefined,
                'aria-describedby': labelId !== null && labelId !== void 0 ? labelId : undefined
            }, props), {
                type: 'number'
            });
        },
        classNames: [
            'swan-pagination-input'
        ]
    }
});

export { PaginationInput };
